import { render } from "./OneClerkComponent.vue?vue&type=template&id=93a24978&scoped=true"
const script = {}

import "./OneClerkComponent.vue?vue&type=style&index=0&id=93a24978&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93a24978"]])

export default __exports__